import { ContentPromotion } from '../../ui/business/ContentPromotion/ContentPromotion';
import { useDirectCompanies } from './ContentPromotion/hooks/useDirectCompanies';
import { useIsAuthorized } from './ContentPromotion/hooks/useIsAuthorized';

export const BusinessContentPromotionDetails: React.FC<{}> = () => {
    const { directCompanies, isLoading } = useDirectCompanies();
    const isAuthorized = useIsAuthorized();

    return (
        <ContentPromotion
            directCompanies={directCompanies}
            isLoading={isLoading}
            isAuthorized={isAuthorized}
        />
    );
};
